// passing the path into variables

const destination1 = '/assets/busesbarriaI/destinations/Destinations1.png';
const destination2 = '/assets/busesbarriaI/destinations/Destinations2.png';
const destination3 = '/assets/busesbarriaI/destinations/Destinations3.png';

const destination = [destination1, destination2, destination3];

const busesbarriaSlides = {
  destination,
};

export default busesbarriaSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/busesbarriaSlides.js